import React from 'react'
import { image } from 'services'
import { Row, Col, Grid } from 'flexbox'
import { companyConfig } from 'globalConfigApp'

import styles from './styles'

export const VideoFrame = (props) => {
  return(
    <div className="video-frame">
      <Grid>
        <Row md={12} className="video-container">
          <h2>Video testimonial de nuestro programa de capacitación</h2>
          <p>Nuestro metodo de coaching y de capacitacion no solo se enfoca en la teoria sino en una aplicacion concreta de nuestras tecnicas durante rol plays que organizamos con clientes. </p>
          <a href="">
            <img
              className="about-logo"
              src={image('landing/section/play.png')}
              alt={companyConfig.name}
            />
          </a>
        </Row>
      </Grid>
      <style jsx global>{styles}</style>
    </div>
  )
}

export default VideoFrame